import styles from './styles.module.scss';

const SidebarListExpanded = ({ t, title, children }) => {
  return (
    <div className={styles.sidebarListExpanded}>
      {<div className={styles.sidebarListExpandedTitle}>{title ? title : t('sensor.unboundSensors')}</div>}
      {children}
    </div>
  );
};

export default SidebarListExpanded;
